export var ProjectSurveyResponseStatus;
(function (ProjectSurveyResponseStatus) {
    ProjectSurveyResponseStatus[ProjectSurveyResponseStatus["Pending"] = 1] = "Pending";
    ProjectSurveyResponseStatus[ProjectSurveyResponseStatus["Active"] = 2] = "Active";
    ProjectSurveyResponseStatus[ProjectSurveyResponseStatus["Rejected"] = 3] = "Rejected";
    ProjectSurveyResponseStatus[ProjectSurveyResponseStatus["Disqualified"] = 4] = "Disqualified";
    ProjectSurveyResponseStatus[ProjectSurveyResponseStatus["QuotaOverLimit"] = 5] = "QuotaOverLimit";
    ProjectSurveyResponseStatus[ProjectSurveyResponseStatus["Testing"] = 6] = "Testing";
    ProjectSurveyResponseStatus[ProjectSurveyResponseStatus["Incomplete"] = 7] = "Incomplete";
})(ProjectSurveyResponseStatus || (ProjectSurveyResponseStatus = {}));
